import { render } from "./px-menu.vue?vue&type=template&id=3300ed75&scoped=true&ts=true"
import script from "./px-menu.vue?vue&type=script&lang=ts"
export * from "./px-menu.vue?vue&type=script&lang=ts"

import "./px-menu.vue?vue&type=style&index=0&id=3300ed75&lang=scss&scoped=true"
import "./px-menu.vue?vue&type=style&index=1&id=3300ed75&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3300ed75"]])

export default __exports__